import {
    Component,
    OnInit,
    HostBinding,
    HostListener,
    Output,
    EventEmitter
} from '@angular/core';

const DARWIN_APP = 'screeps_server.app';
const WIN32_APP = 'screeps_server.exe';
const LINUX_APP = 'screeps_server';

const nw = window.nw;

@Component({
    selector: 'app-nw-server-start',
    templateUrl: './server-start.component.pug',
    styleUrls: ['./server-start.component.less']
})
export class ServerStartComponent implements OnInit {

    public dirname = '';

    @Output() start: EventEmitter<any> = new EventEmitter();

    @HostBinding('hidden') hidden = true;
    @HostBinding('attr.disabled') disabled = null;

    @HostListener('click', ['$event'])
    onClick($event) {
        $event.stopPropagation();

        const cp = nw.require('child_process');
        const path = nw.require('path');

        const options = {
            cwd: this.dirname,
            detached: true
        };

        if (nw.process.platform === 'darwin') {
            cp.spawn('open', [path.resolve(this.dirname, DARWIN_APP)], options);
        }

        if (nw.process.platform === 'win32') {
            cp.spawn(path.resolve(this.dirname, WIN32_APP), options);
        }

        if (nw.process.platform === 'linux') {
            cp.spawn(path.resolve(this.dirname, LINUX_APP), ['--no-sandbox', '--ozone-platform=x11'], options);
        }

        this.disabled = true;

        this.start.emit();
    }

    constructor() {
        try {
            const fs = nw.require('fs');
            const path = nw.require('path');

            this.dirname = path.resolve(path.dirname(nw.process.execPath).replace(/\/nwjs\.app.*$/, ''), 'server');

            fs.statSync(this.dirname);
            this.hidden = false;
        } catch (e) {
            // Noop.
        }
    }

    ngOnInit() {
    }

}
